import React, { Component } from "react";

// import Custom Componenets
import BootstrapTable from "react-bootstrap-table-next";

import Modal from "react-responsive-modal";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

// koneksi
import { Post, Get, Delete, cekLogin } from "../../function/Koneksi";

// css files
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

//json file
// var data = require('../assets/json/company');
const frmDef = {
  uuid: "",
  id_instansi: "",
  kode_surat: "",
  nama: "",
};

class PelayananInstansi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: [],
      status: {
        form: false,
        btnForm: false,
        btnAksi: false,
        formVerifikasi: false,
        statGet: false,
        formReset:false
      },
      awal: "",
      sebelum: "",
      hal: [],
      setelah: "",
      akhir: "",
      statUbah: false,
      dt: frmDef,
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      // =========== Select 2 ============
      frmLayanan: [],
      statLayanan: null,
      dataInstansi: this.props.dataParentToChild
    };
  }

  
  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false
    });
  };

  onRecieveInput = value => {
    this.setState({
      alert: (
        <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
          You wrote: {value}
        </SweetAlert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  // =================================================

  // ================== Ambil data dari db untuk table ==================
  fetch = (params = {}) => {
    let link = "";
    let where = [];
    if (params.where) {
      where = params.where;
    }
    if (params.page) {
      switch (params.page) {
        case ">>":
          link =
            "?page=" +
            Math.ceil(
              this.state.pagination.total / this.state.pagination.per_page
            );
          break;
        case ">":
          link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
          break;
        case "<":
          link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
          break;
        case "<<":
          link = "?page=1";
          break;
        default:
          link = "?page=" + params.page;
          break;
      }
    }
		
		Get('pelayanan-instansi/detail/' + this.state.dataInstansi.uuid, null, (lihat) => {
			// console.log('Data Layanan Instansi CHild')
			// console.log(lihat.results.data)
			if (lihat.results) {
				this.setState({ data: lihat.results.data });
			}
		});
  };

  // Pagination
  pagination = data => {
    // const data = this.state.pagination;
    // console.log(data);
    let awal = "";
    let hal = [];
    let sebelum = "";
    let setelah = "";
    let akhir = "";
    if (data.total > 0) {
      let start = 1;
      let end = 5;
      let n = 0;
      let p = 0;
      if (data.current_page <= 3) {
        start = 1;
        end = 5;
        if (data.last_page > data.current_page) {
          n = data.current_page + 1;
        }
      } else {
        p = data.current_page - 1;
        n = data.current_page + 1;
        start = data.current_page - 2;
        end = data.current_page + 2;
      }
      if (end >= data.last_page - 2) {
        p = data.current_page - 1;
        if (start >= 5) {
          start = data.last_page - 4;
        }
        end = data.last_page;
      }

      for (let i = start; i <= end; i++) {
        let warna = "success";
        if (i == data.current_page) {
          warna = "danger";
        }
        hal.push(
          <a
            onClick={() => this.fetch({ page: i })}
            className={
              "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            }
          >
            {i}
          </a>
        );
      }
      if (p > 0) {
        sebelum = (
          <a
            onClick={() => this.fetch({ page: p })}
            className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<"}
          </a>
        );
      }
      if (n > 0) {
        setelah = (
          <a
            onClick={() => this.fetch({ page: n })}
            className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">"}
          </a>
        );
      }
      awal = (
        <a
          onClick={() => this.fetch({ page: 1 })}
          className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {"<<"}
        </a>
      );
      akhir = (
        <a
          onClick={() => this.fetch({ page: data.last_page })}
          className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {">>"}
        </a>
      );
    }
    this.setState({ awal, sebelum, hal, setelah, akhir });
  };
  // Cari Data Table
  cariData = e => {
    if (e.key == "Enter") {
      let addRole = {
        q: e.target.value
      };
      cekLogin("jenis-surat", addRole, data => {
        this.setState({
          data: data.data.results.data,
          pagination: data.data.results
        });
      });
    }
  };

  // ========================================================================

  // ================== simpan data ==================
  simpan = e => {
    e.preventDefault();

    if(this.state.statLayanan){
      let add = {
        uuid: this.state.dt.uuid,
        id_instansi: this.state.dataInstansi.uuid,
        kode_surat: document.getElementById("kode_surat").value,
        nama: this.state.statLayanan.value,
      };
      
      // console.log("Data Simpan")
      // console.log(add)

      let psn = "";
      let resstat = 204;
      let metode = "create";

      if (add.uuid == "") {
        psn = "Tambah";
        resstat = 201;
        add.uuid = null;
      } else {
        psn = "Ubah";
        resstat = 200;
        metode = "update";
      }
            
      Post("pelayanan-instansi/" + metode, add.uuid, add, res => {
        // console.log(res);
        if (res.status === resstat) {
          this.setState({
            show: true,
            basicType: "success",
            basicTitle: "Data Pelayanan Instansi",
            pesanAlert: "Berhasil " + psn + " Data"
          });
          this.state.status.form = false;
          this.state.status.btnForm = false;
          this.tutupForm();
        }
        else if(res.status == '422'){
          this.setState({
            show: true,
            basicType: "warning",
            basicTitle: "Data Pelayanan Instansi",
            pesanAlert: "Data Pelayanan pada Instansi Telah Tersedia"
          });
        } 
        else {
          this.setState({
            show: true,
            basicType: "danger",
            basicTitle: "Data Pelayanan Instansi",
            pesanAlert: "Gagal " + psn + " Data"
          });
        }
        this.componentDidMount();
        this.forceUpdate();
      });
    }
    else{
      this.setState({
        show: true,
        basicType: "danger",
        basicTitle: "Data Pelayanan Instansi",
        pesanAlert: "Lengkapi Data Terlebih Dahulu"
      });
    }
  };
  // ========================================================================

  // =
  // ============================== Ubah Data ===============================

  ubahData = data => {
  
    this.state.dt.uuid = data.uuid;
    this.state.statInstansi = {value: data.data_instansi.uuid, label: data.data_instansi.nama};
    this.state.statLayanan = {value: data.data_pelayanan.uuid, label: data.data_pelayanan.nama};
    this.state.dt.kode_surat = data.kode_surat;

    this.state.status.btnAksi = false;
    this.forceUpdate();
    this.bukaForm();
  };
 
  // ========================================================================
  // ============================= Hapus Data ===============================
  konfirmHapus = id => {
    this.setState({
      alert: (
        <SweetAlert
          showCancel
          confirmBtnText="Hapus"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="success"
          type="danger"
          title="Yakin ingin hapus data ?"
          onCancel={this.hideAlert}
          onConfirm={() => this.hapusData(id)}
        >
          Proses ini tidak dapat dibatalkan!
        </SweetAlert>
      )
    });
  };

  hapusData = id => {
    this.hideAlert();
    let psn = "Hapus";
    Delete("pelayanan-instansi/delete", id, res => {
      if (res == 200) {
        this.setState({
          show: true,
          basicType: "success",
          basicTitle: "Data Pelayanan Instansi",
          pesanAlert: "Berhasil " + psn + " Data"
        });
      } else {
        this.setState({
          show: true,
          basicType: "danger",
          basicTitle: "Data Pelayanan Instansi",
          pesanAlert: "Gagal " + psn + " Data"
        });
      }
      this.componentDidMount();
    });
  };
  // ========================================================================

  bukaForm = () => {
    this.state.status.form = true;
    this.forceUpdate();
  };

  tutupForm = () => {
    this.state.status.form = false;
    this.state.dt = frmDef
    this.state.statLayanan = null
    this.state.statInstansi = null
    this.forceUpdate();
  };

  tombolAksi = (cell, row) => {
    // console.log(row)
    return (
      <>
        <Button
          size="xs"
          color="success"
          className="btn-icon"
          onClick={() => {
            this.setState({
              judul: "Ubah Perangkat",
              statUbah: false
            });
            this.ubahData(row);
          }}
          disabled={this.state.status.btnAksi}
        >
          <i className="fa fa-pencil"></i>
        </Button>{" "}
        <Button 
          size="xs" 
          color="danger" 
          className="btn-icon" 
          onClick={() => this.konfirmHapus(row.uuid)} disabled={this.state.status.btnAksi}
        >
          <i className="fa fa-trash"></i>
        </Button>
      </>
    );
  };

  changeSelectValue = (e, sel) => {
		if (e) {
			switch (sel) {
				case 'nama':
					this.state.statLayanan = e;
					break;
			}
		} else {
			switch (sel) {
				case 'nama':
					this.state.statLayanan = null;
					break;
			}
		}
		this.state.status.select = false;
		this.forceUpdate();
	};

  componentDidMount() {
    this.fetch({ page: null, where: [] });
    
    Get("master-pelayanan/list", null, data => {
      let frmLayanan = [];
      data.results.map(dt => {
        frmLayanan.push({ value: dt.uuid, label: dt.nama });
      });
      this.setState({ frmLayanan });
    });
  }

  render() {
    // console.log('Data Render CHild');
    // console.log(this.state.dataInstansi);

    const { photoIndex, isOpen } = this.state;

    var size = Math.ceil(
      this.state.pagination.total / this.state.pagination.per_page
    );
    // var size = this.state.pagination.total;
    var from = this.state.pagination.from;
    var page = this.state.pagination.current;
    var to = this.state.pagination.to;
    var total = this.state.pagination.total;
    var data = this.state.data;

    // var data = require('../assets/json/company');

    const frmDef = {
      uuid: "",
      id_instansi: "",
      kode_surat: "",
      nama: "",
    };
    const { SearchBar } = Search;
    const columns = [
      {
        dataField: "data_instansi.nama",
        text: "Nama Instansi",
        sort: true
      },
      {
        dataField: "data_instansi",
        text: "Wilayah",
        sort: true,
        formatter: (cell, obj) => {
          let isinya = obj.data_instansi
          if(isinya.data_kecamatan){
            return (isinya.data_kecamatan.nama);
          }
          else{
            return (isinya.data_kabkota.nama);
          }
        },
      },
      {
        dataField: "kode_surat",
        text: "Kode Surat",
        sort: true
      },
      {
        dataField: "data_pelayanan.nama",
        text: "Jenis Pelayanan",
        sort: true
      },
      {
        dataField: "aksi",
        text: "Aksi",
        isDummyField: true,
        csvExport: false,
        formatter: this.tombolAksi
      }
    ];

    return (
      <div>
        {/* <Breadcrumb title="Penguna" parent="Admin" /> */}
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          onConfirm={this.closeAlert}
        >
          {this.state.pesanAlert}
        </SweetAlert>

        {this.state.alert}

        <div className="row">
          <div className="card-body datatable-react">
            <div className="col-12 text-right">
                <Button size="sm" color="success" className="btn-square" onClick={() => {
                    this.setState({ judul: "Tambah Jenis Pelayanan Instansi", dt: frmDef, prvStat: null, kbktStat: null, kecStat: null, kldsStat: null});  
                    this.state.dt.uuid = null
                    this.state.id_tingkatUser = null
                    this.state.id_jenisUser = null
                    this.forceUpdate();
                    this.bukaForm();
                }}>Tambah Data</Button>
            </div>
            <br/>
            <div className="col-12">
              <BootstrapTable keyField="id" data={data} columns={columns} />
              <div className="pull-right text-white">
                {this.state.awal}
                {this.state.sebelum}
                {this.state.hal.map(dt => {
                  return dt;
                })}
                {this.state.setelah}
                {this.state.akhir}
              </div>
            </div>
          </div>
        </div>
        <br />
       
        <Modal
          size="lg"
          open={this.state.status.form}
          onClose={this.tutupForm}
          styles={{ modal: { width: "80%" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <div size="lg" className="modal-header">
            <h5 className="modal-title">{this.state.judul}</h5>
          </div>
          <Form className="theme-form" onSubmit={this.simpan}>
            <div className="modal-body">
              <input
                className="form-control"
                id="uuid"
                type="hidden"
                placeholder="UUID"
                defaultValue={this.state.dt.uuid}
              />

              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                  Nama Instansi
                </Label>
                <Col sm="9">
                  <div className="row">
                    <div className="col-sm-11">
                      <input
                        className="form-control"
                        id="nama_instansi"
                        type="text"
                        defaultValue={this.state.dataInstansi.nama}
                        readOnly
                      />  
                    </div>
                  </div>
                </Col>
              </FormGroup>

              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                  Kode Surat
                </Label>
                <Col sm="9">
                  <div className="row">
                    <div className="col-sm-11">
                    <input
                      className="form-control"
                      id="kode_surat"
                      type="text"
                      placeholder="Masukkan Kode Surat"
                      required
                      defaultValue={this.state.dt.kode_surat}
                    />
                    </div>
                  </div>
                </Col>
              </FormGroup>

              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                  Nama Pelayanan
                </Label>
                <Col sm="9">
                  <div className="row">
                    <div className="col-sm-11">
                      <Select
                        isDisabled={this.state.status.select}
                        classNamePrefix="select"
                        onChange={e => {
                          this.changeSelectValue(e, "nama");
                        }}
                        defaultValue={this.state.statLayanan}
                        value={this.state.statLayanan}
                        name="nama"
                        options={this.state.frmLayanan}
                        placeholder="Pilih Jenis Pelayanan"
                        isClearable
                      />
                    </div>
                  </div>
                </Col>
              </FormGroup>

            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-warning"
                // disabled={this.state.status.btnForm}
                onClick={this.tutupForm}
              >
                Tutup
              </button>
              <button
                type="submit"
                className="btn btn-success"
                // disabled={this.state.status.btnForm}
              >
                Simpan
              </button>
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default PelayananInstansi;